import { Tab } from "@mui/material"

export interface DashboardTabProps {
  // The instance slug — both the MUI Tabs match value and the URL form the parent navigates to.
  value: string
  name: string
  // onSelect carries the chosen slug (not a DOM event), so the parent can navigate without re-deriving it.
  onSelect: (slug: string) => void
}

// A single presentational dashboard tab; MUI Tabs owns selection. Long names ellipsis-truncate with a
// title tooltip.
export default function DashboardTab({ value, name, onSelect }: DashboardTabProps) {
  return (
    <Tab
      value={value}
      label={name}
      title={name}
      onClick={() => { onSelect(value) }}
      sx={{
        // Label rides above the sliding pill (zIndex) and darkens when selected.
        textTransform: "none",
        letterSpacing: "0.01em",
        fontSize: "0.875rem",
        fontWeight: 500,
        color: "text.secondary",
        zIndex: 1,
        borderRadius: "8px",
        minHeight: "auto",
        py: 0.75,
        px: 2,
        // The theme forces MuiTab minWidth: 160 (built for top-level nav); a switcher tab should hug
        // its label, so collapse the floor and cap long names with the ellipsis below.
        minWidth: 0,
        maxWidth: 200,
        "&.Mui-selected": { color: "text.primary", fontWeight: 600 },
        "&.MuiTab-root": {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    />
  )
}
